import { render, staticRenderFns } from "./LibraryContentHeader.vue?vue&type=template&id=bbce0be8&scoped=true&"
import script from "./LibraryContentHeader.vue?vue&type=script&lang=js&"
export * from "./LibraryContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./LibraryContentHeader.vue?vue&type=style&index=0&id=bbce0be8&prod&lang=scss&scoped=true&"
import style1 from "./LibraryContentHeader.vue?vue&type=style&index=1&id=bbce0be8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbce0be8",
  null
  
)

export default component.exports